import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import {
    HalfSlideIn,
    SlideInBody,
    StandardFirstLevelHeader,
} from '../../../ui/slidein/Slidein.tsx';
import * as FilteredClearancesState from '../../state/FilteredClearancesState.ts';
import { PermitTypeFilterSelection } from './PermitTypeFilter.tsx';
import { OperatorLoginFilterSelection } from './OperatorLoginFilter.tsx';
import { IssueDateFilterSelection } from './IssueDateFilter.tsx';
import { PermitFilterSelection } from './PermitFilter.tsx';
import { Translation } from '../../../common/i18n/Text.ts';
import { filteredClearancesFilterHalfSlideInTexts } from '../../i18n/FilteredClearancesTexts.ts';
import { ValidDateFilterSelection } from './ValidDateFilter.tsx';

export interface FilteredClearancesFilterHalfSlideInTexts {
    title: Translation;
}

export function FilteredClearancesFilterHalfSlideIn() {
    const { storeState, update } = useStore(store => ({
        filter: FilteredClearancesState.Filter.get(store),
    }));
    const { language } = useLanguage();

    return (
        <HalfSlideIn open={storeState.filter.filterSlideInVisible}>
            <StandardFirstLevelHeader
                onClose={() =>
                    update(store =>
                        FilteredClearancesState.Filter.stateWrite(store, {
                            filterSlideInVisible: false,
                        }),
                    )
                }
                title={filteredClearancesFilterHalfSlideInTexts[
                    language
                ].title()}
            />
            <SlideInBody>
                <PermitTypeFilterSelection />
                <OperatorLoginFilterSelection />
                <IssueDateFilterSelection />
                <PermitFilterSelection />
                <ValidDateFilterSelection />
            </SlideInBody>
        </HalfSlideIn>
    );
}
